import { render, staticRenderFns } from "./ItemSnoozes.vue?vue&type=template&id=07f31c30&scoped=true"
import script from "./ItemSnoozes.vue?vue&type=script&lang=js"
export * from "./ItemSnoozes.vue?vue&type=script&lang=js"
import style0 from "./ItemSnoozes.vue?vue&type=style&index=0&id=07f31c30&prod&lang=scss&scoped=true"
import style1 from "./ItemSnoozes.vue?vue&type=style&index=1&id=07f31c30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f31c30",
  null
  
)

export default component.exports